import * as actionTypes from '../../actions/appliedJobs/actionTypes';

export const initialState = {
  appliedJobs: [],
  isLoading: true
};

const appliedJobsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_APPLIED_JOBS:
      return {
        ...state,
        isLoading: false,
        appliedJobs: action.data
      };
    case actionTypes.SET_APPLIED_JOBS_LOADING:
      return {
        ...state,
        isLoading: true
      };
    default:
      return state;
  }
};

export default appliedJobsReducer;
